import { render, staticRenderFns } from "./CompanyIcon.vue?vue&type=template&id=45711b66&scoped=true"
var script = {}
import style0 from "./CompanyIcon.vue?vue&type=style&index=0&id=45711b66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45711b66",
  null
  
)

export default component.exports